import { IDataSourceModalState } from './dataSourceModals.interface';

export const dataSourceModalInitialState: IDataSourceModalState = {
  isOpen: false,
  isNew: true,
  selectedDataSource: null,
  view: 'selectType',
};
